import { Button, Modal, ModalActions } from '@braskai/ui-kit';

import { ModalHeaderDefault } from '@/shared/ui/modal';

type RemoveMemberModalProps = {
  isLoading?: boolean;
  isOpen: boolean;
  onCancel: () => void;
  onRemove: () => void;
};

export const RemoveMemberModal = ({ isLoading, isOpen, onCancel, onRemove }: RemoveMemberModalProps) => (
  <Modal open={isOpen} size="xs" onClose={onCancel}>
    <ModalHeaderDefault
      title="Are you sure you want to remove this member from the Teamspace?"
      subtitle="Once removed, they will lose access to the Teamspace and all projects within it. You can re-add the member later and restore their access."
      onClose={onCancel}
    />

    <ModalActions>
      <Button
        data-testid="teamspace-cancel-remove-member"
        disabled={isLoading}
        variant="outlined"
        fullWidth
        onClick={onCancel}
      >
        Cancel
      </Button>
      <Button
        data-testid="teamspace-confirm-remove-member"
        isLoading={isLoading}
        variant="error"
        fullWidth
        onClick={onRemove}
      >
        Remove
      </Button>
    </ModalActions>
  </Modal>
);
